<template>
  <div class="s_chat_right_info">
   <div class="s-chat-right-customer-container">
      <!-- 头像姓名 -->
      <div class="s-customer-name-img g-flex-align-center">
        <img :src="chatUserInfo.avatar" alt=""/>
        <p class="s-customer-name">
          <span>{{chatUserInfo.name ? chatUserInfo.name : '游客 #' + chatUserInfo.id}}</span>
        </p>
      </div>
      <!-- 添加标签 -->
      <!-- <div class="s-add-tag-container g-flex-align-center">
        <div class="s-add-tag g-flex-align-center">
          <i class="iconfont icon-tianjia"></i>
          <span>添加标签</span>
        </div>
      </div> -->

      <!-- 信息 -->
      <div class="s-customer-info-container">
        <div class="s-customer-source">
          <div class="s-source-item g-flex-align-center">
            <label>标识</label>
            <div class="s-item-val">{{chatUserInfo.client_id ? chatUserInfo.client_id : '无'}}</div>
          </div>
          <div class="s-source-item g-flex-align-center">
            <label>来源</label>
            <div class="s-item-val">{{chatUserInfo.web_title}}</div>
          </div>
          <div class="s-source-item g-flex-align-center">
            <label>系统</label>
            <div class="s-item-val">{{chatUserInfo.system}}</div>
          </div>
          <div class="s-source-item g-flex-align-center">
            <label>浏览器</label>
            <div class="s-item-val">{{chatUserInfo.browsers}}</div>
          </div>
          <div class="s-source-item g-flex-align-center">
            <label>IP</label>
            <div class="s-item-val">
              {{chatUserInfo.ip}}
              <!-- 加入黑名单 -->
              <el-popover placement="bottom" trigger="click" v-model="visible">
                <div class="g-flex-align-center">
                  <el-select v-model="formBlack.expir_time" placeholder="请选择" size="mini">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"/>
                  </el-select>
                  <div style="margin-left: 10px">
                    <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                    <el-button type="text" size="mini" @click="sureAddBlackClick">确定</el-button>
                  </div>
                </div>
                <el-button slot="reference" size="mini" class="s-add-black" type="danger" round v-if="auth.addBlack">加入黑名单</el-button>
              </el-popover>
            </div>
          </div>
          <div class="s-source-item g-flex-align-center">
            <label>地区</label>
            <div class="s-item-val">{{chatUserInfo.ip_address}}</div>
          </div>
        </div>
        
        <!-- 个人信息 -->
        <div class="s-customer-info-card">
          <div class="s-info-item g-flex-align-center" v-for="(item,index) in infoList" :key="index">
            <label>{{item.title}}</label>
            <div class="s-info-val" :class="'s-info-val-' + item.key" @click="infoEditClick(item)">
              <div class="s-info-no-input g-flex-align-center" v-show="item.show">
                <span>{{form[item.key]}}</span>
                <i class="iconfont icon-bianji"></i>
              </div>
              <div class="s-info-input g-flex-align-center" v-show="!item.show">
                <el-input type="textarea" size="mini" v-model="form[item.key]" @blur="inputBlur(item)"></el-input>
              </div>
            </div>
          </div>
          <!-- <div class="s-info-btn g-flex-align-center g-flex-justify-center">
            <el-button type="primary" size="mini">修改</el-button>
            <el-button type="info" size="mini">取消</el-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { apiUpdateClient, apiAddIpBlack } from '@/utils/api.js'
  export default {
    props: {
      chatUserInfo: {
        type: Object,
        default() {
          return {}
        }
      },
      chatUserId: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
      auth: {
        addBlack: this.$global.ApiList.includes(60),
      },
      
      visible: false,

      options: [
        {
          value: 0,
          label: '长期屏蔽'
        },
        {
          value: 60 * 30,
          label: '屏蔽半小时'
        }, 
        {
          value: 60 * 60,
          label: '屏蔽一小时'
        }, 
        {
          value: 60 * 60 * 2,
          label: '屏蔽两小时'
        }, 
        {
          value: 60 * 60 * 6,
          label: '屏蔽六小时'
        }, 
        {
          value:  60 * 60 * 24,
          label: '屏蔽一天'
        }],
        
        formBlack: {
          expir_time: 0,
          ip: ''
        },

        infoList: [
          { title: '姓名', show: true, key: 'name', focus: false },
          { title: '电话', show: true, key: 'mobile', focus: false  },
          { title: '邮箱', show: true, key: 'email', focus: false  },
          { title: 'QQ', show: true, key: 'qq', focus: false  },
          { title: '地址', show: true, key: 'address', focus: false  },
          { title: '备注', show: true, key: 'remark', focus: false  },
        ],
        
        form: {
          name: '',
          mobile: '',
          email: '',
          qq: '',
          address: '',
          remark: '',
        }
      }
    },
    methods: {
      infoEditClick(item) {
        this.$set(item, 'show', false)
      },

      // 失去焦点 更新用户信息
      async inputBlur(item) {
        this.$set(item, 'show', true)
        if(this.form[item.key] === this.chatUserInfo[item.key]) return
        const { success, data } = await apiUpdateClient(Object.assign({}, this.form))
        if(!success) return this.form[item.key] = this.chatUserInfo[item.key]
        this.chatUserInfo[item.key] = this.form[item.key]
        this.$message({ message: data.msg, type: 'success' });
      },

      // 确定加入黑名单
      async sureAddBlackClick() {
          this.formBlack.ip = this.chatUserInfo.ip
          let loading = this.$loading()
          const { success, data } = await apiAddIpBlack(this.formBlack)
          loading.close()
          if(!success) return
          this.$message.success(data.msg)
          this.visible = false
          // 加入黑名单成功
          this.$emit('emitAddblackSuccess', this.chatUserInfo.id)
        },
    },
    watch: {
      chatUserInfo(nval) {
        this.form.id = nval.id
        this.form.name = nval.name
        this.form.mobile = nval.mobile
        this.form.email = nval.email
        this.form.qq = nval.qq
        this.form.address = nval.address
        this.form.remark = nval.remark
      }
    }
  }
</script>

<style lang="scss">
.s_chat_right_info {
  // 客户信息
  .s-chat-right-customer-container {
    .s-customer-name-img {
      padding: 8px 10px 8px 10px;
      img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        vertical-align: middle;
        object-fit: cover;
      }
      .s-customer-name {
        font-size: $small-more-font-size;
        color: $fontColor;
        padding-left: 10px;
      }
    }
    //添加标签
    .s-add-tag-container {
      flex: 1;
      padding: 0px 15px 12px 15px;
      box-shadow: 0 3px 4px 0 #f4f6fb;
      .s-add-tag {
        padding: 0px 8px;
        border: 1px solid rgba(4, 15, 66, 0.2);
        color: $fontColor;
        font-size: $most-font-size;
        border-radius: 4px;
        line-height: 22px;
        i {
          color: $noActiveFontColor;
          font-size: 20px;
        }
      }
    }

    // 信息
    .s-customer-info-container {
      // ip地址之类的
      .s-customer-source {
        border-bottom: 1px solid $chatContainerBg;
        padding: 10px 10px;
        .s-source-item {
          font-size: $most-font-size;
          padding: 8px 0;
          .s-ip-number {
            flex: 1;
          }
          label {
            //flex: 1;
            width: 36px;
            color: rgba(4, 15, 66, 0.7);
            text-align: right;
          }
          .s-item-val {
            padding-left: 10px;
            color: $fontColor;
            flex: 3;
            //word-break: break-all;
            word-break: break-word;
            overflow-wrap: break-word;
            .s-add-black {
              margin-left: 10px;
            }
          }
        }
      }
      // 个人信息之类的
      .s-customer-info-card {
        border-bottom: 1px solid $chatContainerBg;

         padding: 10px 10px;
         font-size: $most-font-size;
         .s-info-item {
          padding: 8px 0;
          label {
            width: 30px;
            color: rgba(4, 15, 66, 0.7);
            text-align: right;
          }
          .s-info-val {
            width: 200px;
            flex: 1;
            padding-left: 10px;
            &.s-info-val-remark {
              .s-info-no-input {
                span {
                  white-space: pre-wrap;
                }
              }
            }
          }
          .s-info-no-input {
            .icon-bianji {
              color: #1880ff;
              padding-left: 10px;
              visibility: hidden;
            }
            &:hover {
              .icon-bianji {
                visibility: visible;
              }
            }
            span {
              display: inline-block;
              width: 200px;
              // @include textEllipsis();
              line-height: 1.6;
            }
          }
         }

         .s-info-btn {
           padding: 20px 0;
           .el-button--primary {
             background: $mainBlue;
           }
         }
      }
    }
  }
}

</style>